import { useEffect, useState } from 'react';
import { pinCountdownStorage } from '@ajaibid/utils';

const useCountdown = (initialMinute) => {
  const [countDown, setCountDown] = useState(initialMinute * 60);
  const [seconds, setSeconds] = useState(0);

  const savedSeconds = pinCountdownStorage.get('seconds');
  const savedCountDown = pinCountdownStorage.get('countDown');

  useEffect(() => {
    const interval = setInterval(() => {

      if (countDown > 0) {
        setCountDown(countDown - 1);
      }

      if (seconds >= 1) {
        setSeconds(seconds - 1);
      } else {
        setSeconds(59);
      }

    }, 1000);

    if (countDown <= 0) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [countDown, seconds]);

  const minutes = Math.floor(countDown / 60);

  const setMinutes = (value) => {

    const savedMinutes = Math.floor(savedCountDown / 60) + 1;
    
    if (savedCountDown && savedCountDown > 1 && value >= 1 && savedMinutes >= value) {
      setSeconds(savedSeconds);
      setCountDown(savedCountDown);
    } else {
      setCountDown(value * 60);
    }
  };

  if (countDown > 0) {
    pinCountdownStorage.set('seconds', seconds);
    pinCountdownStorage.set('countDown', countDown);
  }
  
  const padSecond = seconds.toString().padStart(2, '0');

  return [setMinutes, minutes, padSecond, countDown];
};

export default useCountdown;
